import { render } from "./AssetsDetails.vue?vue&type=template&id=8bcfdbb2"
import script from "./AssetsDetails.vue?vue&type=script&lang=js"
export * from "./AssetsDetails.vue?vue&type=script&lang=js"

import exportComponent from "D:\\develop\\app\\cw\\financial\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__